import React from "react";
import { Link } from "gatsby";
import Layout from "../layout/base";
import SEO from "../components/seo";
import Breadcrumb from "../components/breadcrumb";
import Stage from "../components/stage";
import JSON from "../../data/car-t-therapy.json";
import JSONModals from "../../data/modals.json";
import JSONGlossary from "../../data/glossary.json";
import MorphingBubble from "../components/morphingbubble";
import Accordion from "../components/accordion";
import Modal from "../components/modal";
import Cell from "../components/cell";

const IndexPage = ({ i18n = "en" }) => (
  <Layout site="car-t-therapy" i18n={i18n} url="car-t-cell-therapy">
    <SEO
      title={JSON[i18n].meta.title}
      description={JSON[i18n].meta.description}
      lang={i18n}
    />

    {/* STAGE */}
    <Stage className="mb-5 stage--bg2" site="car-t-therapy" i18n={i18n}>
      <div className="stage__title">
        <Breadcrumb data={JSON[i18n].breadcrumb} i18n={i18n} />
        <h1>{JSON[i18n].stage.title}</h1>
        <p>{JSON[i18n].stage.subtitle}</p>
      </div>
    </Stage>

    {/* ./STAGE */}

    {/* INTRO */}
    <div className="container util-content-mt-1 util-content-mb-1">
      <div className="row">
        <div className="col-12 col-lg-6">
          <h2 className="util-h1  util-color-primary">
            {JSON[i18n].content1.title}
          </h2>
          <p
            className="util-text-1"
            dangerouslySetInnerHTML={{ __html: JSON[i18n].content1.text1 }}
          ></p>
        </div>
        <div className="col-12 col-lg-6">
          <p
            className="util-text-1 "
            dangerouslySetInnerHTML={{ __html: JSON[i18n].content1.text2 }}
          ></p>
        </div>
      </div>
    </div>
    {/* ./INTRO */}

    <div
      className="container  util-content-mt-1 util-content-mb-1"
      style={{ minHeight: "1000px" }}
    >
      <div className="row">
        <div className="col-12 col-lg-12 text-lg-center">
          <h2 className="util-h1 util-color-primary">
            {JSON[i18n].about.title}
          </h2>
        </div>
        <div className="col-12 mb-5">
          <Accordion
            style={{ zIndex: 10 }}
            className="accordion--large accordion--primary accordion--disabled"
            allowMultipleOpen={true}
            disabled={true}
          >
            {JSON[i18n].about.accordion1.map((section, i) => {
              return (
                <div key={i} label={section.title} isOpen={section.open}>
                  <div dangerouslySetInnerHTML={{ __html: section.text }}></div>
                </div>
              );
            })}
          </Accordion>
        </div>
      </div>

      <div className="container pb-5 px-0 position-relative">
        <Cell
          className="d-none d-xxl-block"
          style={{
            width: "300px",
            top: "-30%",
            left: "-40%",
          }}
        >
          <img
            className="lazyload"
            data-src={require("../images/elements/green-bubble-2.svg")}
            alt="Green Bubble 2"
          />
        </Cell>

        <div className="content content--primary ">
          <div className="row">
            <div className="col-12 text-center text-white pb-lg-4 mb-lg-5">
              <h3 className="util-h1 text-white font-weight-normal">
                {JSON[i18n].about.treatment.title}
              </h3>
            </div>
            <ul className="list-circle-horizontal">
              <li>
                <div>
                  <img
                    src={require("../images/icons/Icon_Tropfen.svg")}
                    alt="Icon"
                  />
                  <p
                    dangerouslySetInnerHTML={{
                      __html: JSON[i18n].about.treatment.list[0].title,
                    }}
                  ></p>
                </div>
              </li>
              <li>
                <div>
                  <img
                    src={require("../images/icons/Icon_vaccine.svg")}
                    alt="Icon"
                  />
                </div>
                <p
                  dangerouslySetInnerHTML={{
                    __html: JSON[i18n].about.treatment.list[1].title,
                  }}
                ></p>
              </li>
              <li>
                <div>
                  <img
                    src={require("../images/icons/Icon_Blutkonserve.svg")}
                    alt="Icon"
                  />
                </div>
                <p
                  dangerouslySetInnerHTML={{
                    __html: JSON[i18n].about.treatment.list[2].title,
                  }}
                ></p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12 my-5 position-relative">
          <Cell
            className="d-none d-xxl-block"
            style={{
              width: "300px",
              top: "50%",
              right: "-30%",
            }}
          >
            <img
              className="lazyload"
              data-src={require("../images/elements/green-bubble-2.svg")}
              alt="Green Bubble 2"
            />
          </Cell>
          <Accordion
            style={{ zIndex: 10 }}
            className="accordion--large accordion--primary accordion--disabled"
            allowMultipleOpen={true}
            disabled={true}
          >
            {JSON[i18n].about.accordion2.map((section, i) => {
              return (
                <div key={i} label={section.title} isOpen={section.open}>
                  <div dangerouslySetInnerHTML={{ __html: section.text }}></div>
                </div>
              );
            })}
          </Accordion>
        </div>
      </div>

      <div className="row">
        <div className="col-12 offset-lg-2 col-lg-4 d-flex align-items-center justify-content-center order-2 order-lg-1 text-center text-lg-left mb-5 mb-lg-0">
          <div>
            <p
              className="util-h1 mb-4 "
              dangerouslySetInnerHTML={{ __html: JSON[i18n].trialinfo.title1 }}
            ></p>
            <p
              className="util-text-1 mb-4"
              dangerouslySetInnerHTML={{ __html: JSON[i18n].trialinfo.text }}
            ></p>
            <Link
              to={(i18n !== "en" ? "/" + i18n : "") + "/clinical-trial"}
              className="btn btn--primary btn--bg-gray "
            >
              {JSON[i18n].trialinfo.button1}
            </Link>
          </div>
        </div>
        <div className="offset-2 offset-lg-0 col-8 col-lg-6 order-1 order-lg-2">
          <MorphingBubble id="version7" />
        </div>
      </div>
    </div>

    <div className="d-none d-lg-block util-wave util-wave--bottom util-wave--gray">
      <svg viewBox="0 0 1582 199">
        <g>
          <path d="M674.828609,98.9867925 C969.039593,259.419278 1314.50633,114.718864 1449.09558,90.5422709 C1485.40428,84.0200499 1541.63425,70.1119536 1604.39451,43.0936321 C1602.58079,43.8744414 1600.77189,44.6445681 1598.96877,45.4038763 L1598.9738,210 L-3.13302538,210 L-3.13396366,10.8447642 L-5,10.9763217 C107.948014,3.03300681 452.525786,-22.2343589 674.828609,98.9867925 Z M1890.4328,-193.600233 L1889.52226,-192.177316 C1892.93653,-197.495822 1896.28988,-202.910131 1899.57842,-208.421904 C1896.58272,-203.400953 1893.53318,-198.460781 1890.4328,-193.600233 Z M1922.0228,-249.693257 L1921.53629,-248.710055 C1923.01577,-251.693162 1924.47685,-254.701519 1925.91902,-257.735333 L1921.53644,-248.710344 C1921.69878,-249.037678 1921.8609,-249.365315 1922.0228,-249.693257 Z M1929.19455,-264.740818 L1926.70728,-259.400071 C1927.90352,-261.936409 1929.08657,-264.490458 1930.25616,-267.062337 L1926.70717,-259.399849 C1927.54276,-261.171517 1928.37192,-262.951826 1929.19455,-264.740818 Z M1932.66252,-272.422111 L1931.51669,-269.852755 C1932.63039,-272.334718 1933.73159,-274.83316 1934.82002,-277.348188 L1931.51662,-269.852615 C1931.90007,-270.707159 1932.28204,-271.563656 1932.66252,-272.422111 Z M1936.04968,-280.209351 L1935.72582,-279.451921 C1937.07352,-282.598042 1938.40129,-285.769973 1939.70866,-288.967919 L1935.72572,-279.451681 C1935.83384,-279.704072 1935.94182,-279.956629 1936.04968,-280.209351 Z M1942.57504,-296.104484 L1940.66922,-291.331358 C1941.6822,-293.838408 1942.68265,-296.361349 1943.67037,-298.900281 L1940.66923,-291.331364 C1941.30952,-292.916046 1941.94481,-294.507078 1942.57504,-296.104484 Z M1945.70994,-304.213783 L1944.841,-301.932487 C1945.90215,-304.702342 1946.94819,-307.491085 1947.97881,-310.29884 L1944.8411,-301.932768 C1945.13185,-302.691687 1945.42147,-303.452025 1945.70994,-304.213783 Z M1948.75746,-312.431841 L1948.5766,-311.934299 C1949.78917,-315.265797 1950.98008,-318.623955 1952.14884,-322.008982 L1948.57676,-311.934752 C1948.63705,-312.100383 1948.69728,-312.266079 1948.75746,-312.431841 Z M1954.58377,-329.197049 L1953.10378,-324.79524 C1953.98248,-327.378154 1954.84833,-329.976609 1955.70109,-332.590695 L1953.10384,-324.79542 C1953.60129,-326.257643 1954.09461,-327.724847 1954.58377,-329.197049 Z M1957.35928,-337.745604 L1956.69793,-335.672137 C1957.74226,-338.927728 1958.76637,-342.207393 1959.76986,-345.511304 L1956.69797,-335.672283 C1956.91932,-336.362308 1957.13976,-337.053414 1957.35928,-337.745604 Z M1960.04083,-346.405732 L1959.98325,-346.215269 C1961.04528,-349.725843 1962.08405,-353.263749 1963.09907,-356.829193 L1959.98333,-346.215533 C1960.0025,-346.278924 1960.02167,-346.342324 1960.04083,-346.405732 Z M1965.11547,-364.063517 L1963.99706,-360.012985 C1964.75293,-362.718024 1965.49517,-365.438804 1966.22357,-368.175416 L1963.99715,-360.013295 C1964.37331,-361.359467 1964.74609,-362.709537 1965.11547,-364.063517 Z M1967.50527,-373.062581 L1967.03583,-371.255648 C1967.99358,-374.921844 1968.92658,-378.616266 1969.83432,-382.339128 L1967.03578,-371.255447 C1967.19294,-371.857065 1967.34944,-372.459443 1967.50527,-373.062581 Z M1971.98161,-391.404567 L1970.01528,-383.083016 C1970.8614,-386.569636 1971.68539,-390.081161 1972.48685,-393.617766 L1970.01526,-383.082947 C1970.68463,-385.841205 1971.34015,-388.61505 1971.98161,-391.404567 Z M1974.06485,-400.748896 L1973.22795,-396.924245 C1973.86695,-399.807027 1974.49103,-402.706361 1975.09996,-405.622341 L1973.22806,-396.924736 C1973.5099,-398.196233 1973.78884,-399.470951 1974.06485,-400.748896 Z M1976.04262,-410.20972 L1975.74423,-408.741458 C1976.52974,-412.586537 1977.289,-416.460381 1978.02151,-420.363199 L1975.74437,-408.742117 C1975.84421,-409.230853 1975.94363,-409.720054 1976.04262,-410.20972 Z M1979.67516,-429.483664 L1978.33701,-422.054897 C1978.96255,-425.430522 1979.56812,-428.827753 1980.15339,-432.246724 L1978.33687,-422.054104 C1978.79366,-424.519086 1979.23979,-426.995588 1979.67516,-429.483664 Z M1981.32663,-439.298191 L1980.75452,-435.808899 C1981.26999,-438.908056 1981.76885,-442.024958 1982.25086,-445.159703 L1980.75449,-435.80875 C1980.94754,-436.969406 1981.13826,-438.132551 1981.32663,-439.298191 Z M1982.86605,-449.232025 L1982.69397,-448.078168 C1983.29661,-452.098487 1983.87162,-456.148 1984.41852,-460.226913 L1982.69393,-448.077925 C1982.75156,-448.462358 1982.80893,-448.847058 1982.86605,-449.232025 Z M1985.60215,-469.46043 L1984.77214,-462.898452 C1985.20281,-466.194684 1985.61518,-469.510024 1986.00897,-472.844583 L1984.77219,-462.898831 C1985.05687,-465.077671 1985.33354,-467.26486 1985.60215,-469.46043 Z M1986.79553,-479.756406 L1986.44062,-476.573015 C1986.83032,-480.007813 1987.20039,-483.46287 1987.55055,-486.938302 L1986.44055,-476.572432 C1986.56075,-477.631829 1986.67908,-478.693152 1986.79553,-479.756406 Z M1987.87028,-490.174503 L1987.79061,-489.356001 C1988.20457,-493.58739 1988.5891,-497.848859 1988.9437,-502.140616 L1987.79062,-489.356081 C1987.81729,-489.628764 1987.84385,-489.901571 1987.87028,-490.174503 Z M1989.65729,-511.379871 L1989.20195,-505.33879 C1989.46717,-508.701071 1989.71408,-512.081845 1989.94244,-515.48121 L1989.20192,-505.338398 C1989.36025,-507.345625 1989.51206,-509.359442 1989.65729,-511.379871 Z M1990.36627,-522.168549 L1990.19061,-519.298871 C1990.43997,-523.267382 1990.66414,-527.261075 1990.86276,-531.280105 L1990.19058,-519.298499 C1990.2506,-520.253723 1990.30917,-521.210405 1990.36627,-522.168549 Z M1990.95002,-533.08216 L1990.92713,-532.60217 C1991.14018,-537.044438 1991.32204,-541.517598 1991.47223,-546.021859 L1990.92705,-532.600546 C1990.93475,-532.761043 1990.94241,-532.921581 1990.95002,-533.08216 Z M1991.73531,-555.286994 L1991.59115,-549.820188 C1991.69084,-553.225306 1991.77249,-556.648095 1991.83589,-560.088643 L1991.59117,-549.82088 C1991.64437,-551.637882 1991.69242,-553.459915 1991.73531,-555.286994 Z M1991.93355,-566.579624 L1991.90209,-564.147635 C1991.9672,-568.733657 1992,-573.351042 1992,-578 L1991.93355,-566.579624 L1991.93355,-566.579624 Z"></path>
        </g>
      </svg>
    </div>

    <div className="util-bg-secondary--mobile util-content-pt-2--lg util-content-pb-2">
      <div className="container position-relative">
        <div className="row">
          <div className="col-12 mt-5 mb-3">
            <p className="util-h1  text-lg-left util-color-black">
              {JSONGlossary[i18n].title}
            </p>
          </div>
          <div className="col-12 my-4 mb-5 mb-lg-0">
            <Accordion
              className="accordion accordion--large accordion--secondary accordion--mobile accordion--glossary"
              allowMultipleOpen={JSONGlossary[i18n].allowMultipleOpen}
              disabled={false}
            >
              {JSONGlossary[i18n].accordion
                .filter((item) => item.visible.includes("therapy"))
                .map((section, i) => {
                  return (
                    <div key={i} label={section.title} isOpen={section.open}>
                      <p
                        className="util-text-1"
                        dangerouslySetInnerHTML={{ __html: section.text }}
                      ></p>
                    </div>
                  );
                })}
            </Accordion>
          </div>
        </div>
      </div>
    </div>

    {JSONModals[i18n].map((modal, i) => {
      return (
        <Modal
          key={i}
          id={modal.id}
          eventCategory={modal.eventCategory}
          eventAction={modal.eventAction}
          eventLabel={modal.eventLabel}
          i18n={i18n}
        >
          <h3>{modal.title}</h3>
          <p
            dangerouslySetInnerHTML={{
              __html: modal.text,
            }}
          ></p>
        </Modal>
      );
    })}
  </Layout>
);

export default IndexPage;
